// extracted by mini-css-extract-plugin
module.exports = {"homeButton":"AuthHomeButton_homeButton__cd_4y","rotate":"AuthHomeButton_rotate__3b3R4","slideIn":"AuthHomeButton_slideIn__3a-rf","fadeIn":"AuthHomeButton_fadeIn__17LF6"};